import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  current: false,
  controls: false,
  playing: false,
  sidebar: false,
  currentPlaylist: [],
};

export const playerSlice = createSlice({
  name: "player",
  initialState,
  reducers: {
    setCurrent: (state, action) => {
      state.current = action.payload;
    },
    setControls: (state, action) => {
      state.controls = action.payload;
    },
    setPlaying: (state, action) => {
      state.playing = action.payload;
    },
    setSidebar: (state, action) => {
      state.sidebar = action.payload;
    },
    setCurrentPlaylist: (state, action) => {
      state.currentPlaylist = action.payload;
    },
  },
});

export const {
  setControls,
  setCurrent,
  setPlaying,
  setSidebar,
  setCurrentPlaylist,
} = playerSlice.actions;

export default playerSlice.reducer;
